import { render, staticRenderFns } from "./ContentAdd.vue?vue&type=template&id=89f88886&scoped=true"
import script from "./ContentAdd.vue?vue&type=script&lang=js"
export * from "./ContentAdd.vue?vue&type=script&lang=js"
import style0 from "./ContentAdd.vue?vue&type=style&index=0&id=89f88886&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89f88886",
  null
  
)

export default component.exports